import React, {useState} from 'react';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../../components/block/Block';
import Button from '../../../../components/button/Button';
import Icon from '../../../../components/icon/Icon';
import {Card, CardBody, Col, Form, Row} from 'reactstrap';
import {FormProvider, useForm} from 'react-hook-form';
import UserForm from '../../../administrator/users/components/UserForm';
import {useNavigate} from 'react-router-dom';
import {IUserData} from '../../../../shared/interfaces/User';
import {yupResolver} from '@hookform/resolvers/yup';
import {usersManagementApi} from '../../../../api';
import {userSchema} from '../../../administrator/users/components/UserCreate';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../store';

const UserCreate = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {roles} = useSelector((state: RootState) => state.auth.user);
  const [passState, setPassState] = useState(false);
  const methods = useForm<IUserData>({
    resolver: yupResolver(userSchema),
  });
  const isCompanyAdmin = roles?.some((role) => role === 'ROLE_COMPANY_ADMIN');

  const onFormSubmit = async (state: IUserData) => {
    const formData = new FormData();
    !!state.file && formData.append('picture', state.file[0]);
    formData.append('body', JSON.stringify(state));
    const {data} = await usersManagementApi.createUser(formData);
    if (data) {
      navigate('/app/management/users');
    }
  };
  return (
    <Block size="lg" className="mt-3">
      <BlockHead>
        <BlockHeadContent>
          <div className="row align-items-center gx-0 gx-lg-2 justify-content-between">
            <div className="col-md-10 col-12">
              <BlockTitle tag="h4">{t('management.users.createUser')}</BlockTitle>
            </div>
            <div className="col-md-2 col-12 text-end">
              <Button
                className="btn-block"
                color="secondary"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <Icon name="arrow-long-left" />
                {t('general.back')}
              </Button>
            </div>
          </div>
        </BlockHeadContent>
      </BlockHead>
      <Card className="card-bordered card-preview">
        <CardBody>
          <FormProvider {...methods}>
            <Form onSubmit={methods.handleSubmit(onFormSubmit)} className="py-3">
              <UserForm
                passState={passState}
                formState={methods.formState}
                setPassState={setPassState}
                register={methods.register}
                errors={methods.formState.errors}
                isAdmin={false}
                isCompanyAdmin={isCompanyAdmin}
              />
              <Row>
                <Col>
                  <Row>
                    <Col className={'text-end'}>
                      <Button color="primary">
                        <Icon name="plus-sm" />
                        {t('general.create')}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </CardBody>
      </Card>
    </Block>
  );
};

export default UserCreate;
